import {atom} from 'recoil';
import {newsType} from '../../types/news';

export const singleNews = atom<newsType | undefined>({
  key: 'singleNews',
  default: undefined,
});
